import { BasePublicApi } from '#packages/apilib';
import { HiddenElementsScope } from './hiddenElementsScope';

type OpenMobileHiddenPanelOrigin =
  | 'hidden_panel_open_button'
  | 'hide_element_flow'
  | 'interactions_gfpp_tooltip'
  | 'section_hidden_notification'
  | 'optimize_mobile_text_notification';

const MOBILE_HIDDEN_PANEL_NAME = 'hiddenElements.panels.mobileHiddenPanel';
const BI_ORIGIN = 'hidden_panel';

export const openMobileHiddenPanel = async (
  scope: HiddenElementsScope,
  origin: OpenMobileHiddenPanelOrigin,
) => {
  const { editorAPI, privateApi, store } = scope;

  await privateApi.refreshHiddenElements();
  editorAPI.selection.deselectComponents();
  editorAPI.panelManager.openPanel(MOBILE_HIDDEN_PANEL_NAME, {
    // the following params are needed only to be sent with bi event by
    // "panelManager". I'll update comment to make it more clear
    origin,
    hidden_elements_total_count: store.getHiddenElementsTotalCount(),
  });

  if (editorAPI.zoomMode.isZoomedByUser()) {
    await editorAPI.zoomMode.exitZoomMode({
      biParams: { origin: BI_ORIGIN },
      clickedByUser: false,
    });
  }
};

export const isMobileHiddenPanelOpened = ({
  editorAPI,
}: HiddenElementsScope): boolean => {
  return editorAPI.panelManager.isPanelOpened(MOBILE_HIDDEN_PANEL_NAME);
};

export const closeMobileHiddenPanel = ({ editorAPI }: HiddenElementsScope) => {
  editorAPI.panelManager.closePanelByName(MOBILE_HIDDEN_PANEL_NAME);
};

export class HiddenElementsApi extends BasePublicApi<HiddenElementsScope> {
  closeMobileHiddenPanel = this.bindScope(closeMobileHiddenPanel);
  openMobileHiddenPanel = this.bindScope(openMobileHiddenPanel);
  isMobileHiddenPanelOpened = this.bindScope(isMobileHiddenPanelOpened);
}
